module.exports = __webpack_public_path__ + "static/intro.50c630a6.webm";


//////////////////
// WEBPACK FOOTER
// ./src/video/intro.webm
// module id = 528
// module chunks = 35783957827783